const ClarityCall = () => {
    return (
        <section className="clarity-call section-spacing" aria-label="What to expect from a Discovery Session">
            <div className="card-section-inner">
                <div className="card-body">
                    <div className="clarity-call-layout">
                        <div className="clarity-call-content">
                            <h2 className="font-semibold text-brand-800">What to Expect from a Discovery Session?</h2>
                            <p className="text-textBody">
                                In a 60-minute session, we'll:
                            </p>
                            <ul className="text-textBody list-disc pl-5 flex flex-col gap-2">
                                <li>Explore your current challenges and areas where you feel stuck.</li>
                                <li>Identify your goals and what's holding you back from achieving them.</li>
                                <li>Create a tailored plan for your healing to move forward with freedom.</li>
                            </ul>
                            <p className="font-semibold text-textHeading mt-1">
                                Whether you're looking to improve confidence, find yourself again, or make a career change, this call is designed to give you the insight and momentum you need.
                            </p>
                        </div>
                        <img className="clarity-call-image" src={`${process.env.PUBLIC_URL}/assets/why_me_illustration.jpg`} alt="Discovery session with Vidya Sireesha - trauma informed therapy and healing" loading="lazy" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ClarityCall;
